// src/pages/permissions/PermissionsPage.js

import React, { useMemo } from 'react'; // Keep useMemo import
import GenericListPage from '../GenericListPage';
import PermissionForm from './PermissionForm';

const permissionColumns = [
  { header: 'ID', key: '_id', render: (permission) => permission._id.substring(0, 8) + '...' },
  { header: 'Permission Name', key: 'name' },
  { header: 'Description', key: 'description' },
];

const PermissionsPage = () => {
  // --- FIX: Move useMemo inside the functional component ---
  const permissionFilterConfig = useMemo(() => [
    {
      name: 'name',
      type: 'text',
      label: 'Permission Name',
    },
  ], []); // Empty dependency array means it's created once on mount

  return (
    <GenericListPage
      title="Permissions"
      permission="manage_permissions"
      entityEndpoint="permissions"
      columns={permissionColumns}
      FormComponent={PermissionForm}
      filterConfig={permissionFilterConfig}
    />
  );
};

export default PermissionsPage;
